import React, { useEffect, useState } from 'react';
import { IoMdCheckmark } from 'react-icons/io';
import ReactTooltip from 'react-tooltip';
import { cancelSubscription, changeSubscription } from '../../firebase/functions';
import useAuth from '../../hooks/useAuth';
import Button from '../inputs/Button';
import AppModal from '../layout/AppModal';
import SpotLoader from '../misc/SpotLoader';

export const CheckListItemSubtitle = ({ children, ...rest }) => <div className="text-xs text-white">{children}</div>;
const CheckListItem = ({ children, ...rest }) => <div className="flex text-lg mb-1" {...rest}>
    <IoMdCheckmark className="mx-2 mt-1 " color={''} />
    <div>{children}</div>
</div>;
export const CheckList = ({ items = [], children = null, ...rest }) => <div>
    {children || items?.map(i => <CheckListItem key={`${i}`}>{typeof i === "string" ? i : <>{i[0]}<CheckListItemSubtitle>{i[1]}</CheckListItemSubtitle></>}</CheckListItem>)}
</div>;
const Separator = () => <div className="w-full bg-gray-200 m-3 opacity-50 rounded-md" style={{ height: 1 }} />;

const PLAN_TO_NUMBER = {
    "free": 0,
    "member": 1,
    "platinum": 2
}

const PLAN_TO_PADDLE_ID = {
    "member": 762911,
    "platinum": 762912
}


export function Price({ title, descr, owns, plan, price = null }) {
    const { user } = useAuth()

    const [loading, setLoading] = useState(false)

    const onGetPlan = () => {
        // setLoading(true)
        // return
        // @ts-ignore
        const Paddle = window.Paddle;
        if (plan === "free") {
            if (owns) {
                return
            } else if (!user?.subscription) {
                cancelSubscription()
            }
            else {
                Paddle.Checkout.open({
                    override: user?.subscription?.cancel_url
                })
            }
        }
        if (owns) {

            if (user.subscription)
                Paddle.Checkout.open({
                    override: user?.subscription?.update_url
                })
        } else {
            if (!user.subscription || user.plan === "free")
                Paddle.Checkout.open({ product: PLAN_TO_PADDLE_ID[plan], email: user?.email, passthrough: user?.uid || user?.id });
            else {
                setLoading(true)
                changeSubscription({ newPlanId: PLAN_TO_PADDLE_ID[plan] })
            }
        }
    }

    useEffect(() => {
        if (loading) setLoading(false)
    }, [user])
    const [clickedPurchase, setClickedPurchase] = useState(false);
    const hasSponsoredPlan = !user?.subscription && user?.plan
    return <div style={{ width: 300, minHeight: 300 }} className=" bg-bgactive flex-shrink-0 rounded-md shadow-md items-center flex-col flex p-6 m-2">

        <div className='flex justify-between w-full'>

            {price && <div className=" text-2xl">
                {price}
            </div>}
            <div className={` text-2xl ${price && 'opacity-60'} `}>
                {title}
            </div>


        </div>

        <Separator />
        <div className="w-full flex text-sm mb-4 ">
            {descr}
        </div>

        <div className="mt-auto w-full">
            <div className='text-xs font-sans text-center my-2 text-light-gray'>
                {user?.subscription && owns && user.plan !== "free" && `Next payment on ${user.subscription.next_bill_date}`}
                {(plan !== "free" && user?.subscription && user.plan === "member" && plan === "platinum") && <div className=' leading-3 text-xxs'>
                    You'll only be charged for the difference between your current and new plan for the rest of the billing cycle.
                </div>}
            </div>
            {(plan !== "free" || !hasSponsoredPlan) && <Button onClick={onGetPlan} id={`${title}-price-button`} secondaryStatic={!owns} disabled={owns && plan === "free"} className={`${!owns && 'text-white'} ${owns && plan !== 'free' && !user.subscription && 'cursor-default'} w-full`}>
                {!loading ?
                    owns ? (plan === "free" ? "Current plan" : (user.subscription ? 'Update payment' : 'Sponsored')) : `Switch to ${title}`
                    : <SpotLoader className="w-4 h-4" />}
                {/* : "Coming soon"} */}

            </Button>}
        </div>

    </div>;
}
